module.exports = __webpack_public_path__ + "img/suicide2-original.9bddb608.png";